import {ServiceTypeEntity,} from "@ots-frontend/ots-data";
import {useCallback} from "react";
import {useNavigate} from "react-router-dom";
import {ServiceTypeAction} from "./ServiceTypeActionMenu";
import {useServiceTypeMutation} from "../../../hooks/useServiceTypeMutation";

export type UseServiceTypeActionProps = {}

export type UseServiceTypeActionResult = {
  onServiceTypeActionClick: (serviceType: ServiceTypeEntity, action: ServiceTypeAction) => void;
}

export const useServiceTypeAction = (props: UseServiceTypeActionProps = {}): UseServiceTypeActionResult => {
  const {} = props

  const navigate = useNavigate();

  const {
    deleteServiceType,
  } = useServiceTypeMutation()

  const _onServiceTypeActionClick = useCallback((serviceType: ServiceTypeEntity, action: ServiceTypeAction) => {
    if (action === "EDIT") {
      navigate(`/service-types/form`, {state: {id: serviceType.id}})
    } else if (action === "DELETE") {
      deleteServiceType(serviceType.id, undefined)
    }
  }, [navigate, deleteServiceType])

  return {
    onServiceTypeActionClick: _onServiceTypeActionClick
  }
}
